export default [
    {
        name: 'xocAuth',
        hideLabel: true,
        component: {
            type: 'v-autocomplete',
            props: {
                label: 'MSO user',
                dense: true,
                clearable: true
            }
        }
    },
    {
        name: 'currentVenueOnly',
        hideLabel: true,
        component: {
            type: 'v-checkbox',
            props: {
                label: 'Limit to current venue only',
                class: 'mt-0'
            }
        }
    }
];
